<template>
<!-- pc_index页面 -->
  <div class='pc_iindexs'>
    <div class='tab'>
      <el-menu
        :router='true'
        :default-active='this.$route.path'
        class='el-menu-demo'
        mode='horizontal'
        @select='handleSelect'
        background-color='#545c64'
        text-color='#fff'
        active-text-color='#ffd04b'
      >
        <el-menu-item v-for='item in navList' :key='item.id' :index='item.path'>{{item.name}}</el-menu-item>
      </el-menu>
    </div>

    <div class='pc_main'>
      <router-view></router-view>
    </div>
  </div>
</template>



<script>
export default {
  name: 'pc_index',
  data() {
    return {
      navList:[
        {
          id:1,
          path:'/home/pc/index/banner',
          name:'banner图管理'
        },
        {
          id:2,
          path:'/home/pc/index/event',
          name:'赛事管理'
        }
      ],
      activeIndex: '/home/pc/index/banner'

    };
  },
  methods: {
    // handleSelect(key, keyPath) {
    handleSelect(key) {
      // console.log(key, keyPath);
      this.activeIndex=key;
    }
  }
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
/* .pc_index {
  margin-left: -20px;
} */
.tab {
  width: 100%;
}
.pc_main {
  margin-top: 10px;
  height: 100%;
}
</style>